const schema = require('../plugin.schema.json')
export { schema }
export { SphereonKeyManager, sphereonKeyManagerMethods } from './agent/SphereonKeyManager'
export * from './types/ISphereonKeyManager'
export * from '@veramo/key-manager'
